module.exports = __webpack_public_path__ + "img/4-01-05-directions.2ced93a8.svg";